import { Layer } from "./layer"

export interface ChangeData {
    layerId: number,
    changeType: ChangeType,
    features: Feature[] 
}
export interface Feature {
    objectId: number,
    attribute: any,
    geometry: any
}
export interface ApplyFeatureData {
    layer: Layer,
    changeType: ChangeType,
    feature: Feature
}

export enum ChangeType {
    add = "add",
    edit = "edit",
    remove = "remove"
}